module.exports = __webpack_public_path__ + "img/bg10.415a049f.gif";